import { Component, OnInit, ViewChild } from '@angular/core';

import * as xlsx from 'xlsx';
import { Utils } from 'src/app/utils/utils';
import { DateUtils } from 'src/app/utils/date-utils';
import { AppComponent } from 'src/app/app.component';
import { NumberUtils } from 'src/app/utils/number-utils';
import { environment } from 'src/environments/environment';
import { CustomForms } from 'src/app/components/forms/custom-forms';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { DateIdentificacionModel } from 'src/app/services/cerraduras/models/dateIdentificacion';
import { IdentificacionCerraduraModel } from 'src/app/services/cerraduras/models/identificacionCerradura';

import { ModeloSelectComponent } from 'src/app/components/modelo-select/modelo-select.component';
import { PeriodoSelectComponent } from 'src/app/components/periodo-select/periodo-select.component';

@Component({
  selector: 'app-listado-identificacion',
  templateUrl: './listado-identificacion.component.html',
  styleUrls: ['./listado-identificacion.component.css']
})
export class ListadoIdentificacionComponent extends CustomForms implements OnInit {
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('periodoSelect') periodoSelect: PeriodoSelectComponent;
  cerradura: boolean;
  unSelect: boolean;
  elementosSelect: ElementoModel[] = [];
  identificacion: IdentificacionCerraduraModel = new IdentificacionCerraduraModel;
  identificaciones: IdentificacionCerraduraModel[] = [];
  dateFin = new Date();
  dateInicio = new Date();
  dateIdentificacion: DateIdentificacionModel = new DateIdentificacionModel();
  // grid
  dataAdapter: any;
  source: any;
  private componentRef = null;
  public theme = environment.tema;
  public langGrid = JqWidgets.getLocalization('es');
  public columns = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'idCerradura', hidden: true },
    { text: 'idElemento', columntype: 'textbox', filtertype: 'textbox', datafield: 'idElemento', hidden: true },
    {
      text: this.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreElemento', cellsrenderer: this.renderText, aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            NumberUtils.format(aggregates["Total"], 0) + '</div>';
        }
        return renderstring;
      }
    },
    { text: 'Ns Cerradura', columntype: 'textbox', filtertype: 'textbox', datafield: 'nsCerradura', hidden: false },
    { text: this.translate('Ciudadano'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombreCiudadano', cellsrenderer: this.renderCiudadano },
    { text: this.translate('Fecha'), columntype: 'datetimeinput', filtertype: 'textbox', datafield: 'fecha', cellsrenderer: this.renderRow },
    { text: this.translate('Medio'), columntype: 'textbox', filtertype: 'textbox', datafield: 'medio', cellsrenderer: this.renderMedio },
    { text: this.translate('Aporte'), columntype: 'checkbox', filtertype: 'bool', datafield: 'aporte' },
    { text: this.translate('Tarjeta_master'), columntype: 'checkbox', filtertype: 'bool', datafield: 'tarjetaMaster' },
    { text: this.translate('Apertura_tapa'), columntype: 'checkbox', filtertype: 'bool', datafield: 'aperturaTapa' },
    { text: this.translate('No_cerro_tapa'), columntype: 'checkbox', filtertype: 'bool', datafield: 'noCerroTapa' },
  ];

  constructor(private serviceCerraduras: CerraduraService) {
    super();
  }

  ngOnInit(): void {
    this.getIdentificaciones(this.dateIdentificacion);
  }

  ngAfterViewInit(): void {
    this.addCustomForm(this.form);
    this.form.setTitle(AppComponent.translate('Informacion_identificacion'));
    Utils.renderSizeGrid(this.grid);
  }

  async getIdentificaciones(date: DateIdentificacionModel) {
    this.source = {
      datatype: 'json',
      dataFields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'nombreElemento', type: 'string', map: 'nombreElemento' },
        { name: 'idElemento', type: 'number', map: 'idElemento' },
        { name: 'nombreCiudadano', type: 'string', map: 'nombreCiudadano' },
        { name: 'nsTarjeta', type: 'string', map: 'nsTarjeta' },
        { name: 'nsCerradura', type: 'string', map: 'nsCerradura' },
        { name: 'fecha', type: 'date', map: 'fecha' },
        { name: 'medio', type: 'number', map: 'medio' },
        { name: 'aporte', type: 'bool', map: 'aporte' },
        { name: 'tarjetaMaster', type: 'bool', map: 'tarjetaMaster' },
        { name: 'aperturaTapa', type: 'bool', map: 'aperturaTapa' },
        { name: 'noCerroTapa', type: 'bool', map: 'noCerroTapa' },
        { name: 'fechaRecibido', type: 'date', map: 'fechaRecibido' },
      ],
      localdata: this.identificaciones,
    };
    this.dataAdapter = new jqx.dataAdapter(this.source);

    const t = setTimeout(() => {
      clearTimeout(t);
      this.grid.autoresizecolumns();
    }, 500);
  }

  renderRow(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {
      let date = new Date(value);
      return '<div style="margin-left: 3px; margin-top: 8px">' + DateUtils.formatDateTimeShort(date, true) + '</div>';
    }
  }

  renderMedio(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value == 0) {
      return '<div style="margin-left: 4px; margin-top: 8px;">NFC</div>';
    } else {
      return '<div style="margin-left: 4px; margin-top: 8px;">BT</div>';;
    }
  }

  renderCiudadano(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    // si el idElemento es 0, mostra el nsCerradura
    if (rowdata.nombreCiudadano == null && rowdata.nsTarjeta == null) {
      return '';
    } else if (rowdata.nombreCiudadano == null && rowdata.nsTarjeta == null) {
      return '<div style="margin-right: 4px; margin-top: 8px;">' + rowdata.nsTarjeta + '</div>';

    }
  }

  renderText(row: number, columnfield: string, value: any, defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (rowdata.idElemento == 0 || rowdata.idElemento == null) {
      return '';
    } else if (rowdata.idElemento == 0 || rowdata.nombreElemento == null && rowdata.nsCerradura == null) {
      return '';
    } else {
      return '<div style="margin-right: 4px; margin-top: 8px;">' + rowdata.nombreElemento + '</div>';
    }
  }
  /**Inicializa el componente
  */
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  // recojo los elementos seleccionados del grid y los añado al array de elementos seleccionados sin repetir elementos
  // selecElement(elemento: any) {
  //   this.elementosSelect = elemento.listElement;
  //   // si no hay elementos seleccionados, no se muestra nada
  //   if (this.elementosSelect.length <= 0 && this.source) {
  //     this.identificaciones = [];
  //     this.source.localdata = this.identificaciones;
  //   } else {
  //     if (elemento.quitCheck !== null) {
  //       this.identificaciones = this.identificaciones.filter(identificacion => identificacion.id_cerradura !== elemento.quitCheck.cerradura.Id)
  //       this.source.localdata = this.identificaciones;
  //     }
  //   }
  //   this.grid.updatebounddata();
  // }

  selecElement(listElement: any) {
    this.elementosSelect = listElement;
    if (this.elementosSelect.length <= 0 && this.source) {
      this.identificaciones = [];
      this.source.localdata = this.identificaciones;
      this.grid.updatebounddata();
    }
  }

  // asigno las fechas del periodo seleccionado
  onAceptar(event: any) {
    this.dateInicio = this.periodoSelect.getFechaIni();
    this.dateFin = this.periodoSelect.getFechaFin();
    this.dateIdentificacion.Desde = this.dateInicio;
    this.dateIdentificacion.Hasta = this.dateFin;
    this.onSearch();
    //this.getAlarmasByCerraduras(this.dateIdentificacion);
  }

  // recojo las identificaciones por cerradura y por fechas
  async onSearch() {
    this.identificaciones = await this.serviceCerraduras.getIndentificacionesDate(this.dateIdentificacion);
    if (this.elementosSelect.length > 0) {
      this.identificaciones = this.identificaciones.filter((identificacion, index) => {
        return this.elementosSelect.slice(0, index).some((elem) => elem.cerradura.id == identificacion.id_cerradura || identificacion.idElemento == 0);
      });
    }
    // if (!this.elementosSelect.length) {
    //   this.identificaciones = [];
    // }
    this.source.localdata = this.identificaciones;
    this.grid.updatebounddata(this.identificaciones);
  }

  onExportar(event: any) {
    const json = JSON.parse(JSON.stringify(this.grid.getdisplayrows()));
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(json);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Hoja1');
    xlsx.writeFile(wb, DateUtils.formatDateAMDhms(new Date()) + '_InformeIdentificacion.xlsx');
  }

  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  onCollapse(event) {
    ModeloSelectComponent._this.onCollapse();
  }

  onExpand(event) {
    ModeloSelectComponent._this.onExpand();
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
